import './FaleConoscoTitle.css'

function FaleConoscoTitle(){
    return(
        <>
        <section className="fale-conosco-title-section">
            <h1 className="fale-conosco-title">Fale Conosco</h1>
            <p className="fale-conosco-desc">Tem algo a dizer? Envie-nos uma mensagem e<br></br>
            responderemos o mais breve possível.</p>
        </section>
        </>
    )
}

export default FaleConoscoTitle;